import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { t } from "../helpers/format"
import { SWATCH_STYLES } from "../helpers/states"

const Swatch = ({ state }) => (
  <span className="inline-flex items-center gap-1.5">
    <span className={`relative inline-grid place-items-center w-[18px] h-[14px] rounded-[4px] ${SWATCH_STYLES[state]}`}>
      {state === "closed" && <FontAwesomeIcon icon="lock" className="text-[7px] text-white" />}
    </span>
    {t(`legend.${state}`)}
  </span>
)

const Marker = ({ children, label }) => (
  <span className="inline-flex items-center gap-1.5">
    {children}
    {label}
  </span>
)

const Legend = ({ weeklyMax }) => (
  <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-3 text-[11.5px] text-slate-600">
    {["planned", "modified", "signed", "approved", "rejected", "closed"].map(state => <Swatch key={state} state={state} />)}
    <span className="h-3.5 w-px bg-slate-200" />
    <Marker label={t("legend.over_max")}>
      <span className="inline-grid place-items-center w-[14px] h-[14px] rounded-full bg-rose-600 text-white text-[9px] font-bold">!</span>
    </Marker>
    {weeklyMax > 0 && (
      <Marker label={t("legend.over_week", { hours: weeklyMax })}>
        <span className="inline-block w-[18px] h-[14px] rounded-[4px] bg-orange-300 p-[2px]"><span className="block w-full h-full rounded-[2px] bg-slate-200" /></span>
      </Marker>
    )}
    <Marker label={t("legend.geofence")}>
      <FontAwesomeIcon icon="location-dot" className="text-orange-600" />
    </Marker>
    <Marker label={t("legend.running")}>
      <span className="relative inline-flex w-[8px] h-[8px]">
        <span className="absolute inline-flex w-full h-full rounded-full bg-brand-400 opacity-75 animate-ping" />
        <span className="relative inline-flex w-[8px] h-[8px] rounded-full bg-brand-500" />
      </span>
    </Marker>
    <Marker label={t("legend.meal")}>
      <FontAwesomeIcon icon="utensils" className="text-slate-400" />
    </Marker>
  </div>
)

export default Legend
